import React from "react";
import { OneRow, TwoRow } from "../../core/layouts";
import useResponsive from "../../core/hooks/useResponsive";
import variables from "../../themes/base/styles/variables";

export const UserOperationAndRepairAuditContainerStyles = {
  checkboxContainer: {
    display: variables.dFlex,
    gap: variables.gapXS,
  },
  bottomSectionStyle: {
    marginTop: variables.marginLg2,
  },
};

export default function UserOperationAndRepairAuditLayout({
  topSection,
  bottomSection,
}) {
  const responsive = useResponsive();
  return responsive.isSm ? (
    <OneRow
      section={
        <div
          style={UserOperationAndRepairAuditContainerStyles.checkboxContainer}
        >
          {topSection}
          {bottomSection}
        </div>
      }
    />
  ) : (
    <TwoRow
      topSection={topSection}
      bottomSection={bottomSection}
      bottomSectionStyle={
        UserOperationAndRepairAuditContainerStyles.bottomSectionStyle
      }
    />
  );
}
